import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 13 12'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='m.673.52 4.522 6.045-4.55 4.916h1.024l3.983-4.304 3.219 4.304h3.485L7.58 5.095 11.815.52H10.79L7.122 4.483 4.158.52zm1.506.754H3.78l7.07 9.452H9.249z'
    />
  </svg>
)
export default SvgComponent
